import React from 'react';

import { Button, Icon } from 'rsuite';

//Componentes de roteamento
import { Link } from "react-router-dom";

import logo from './../assets/logo.webp';
import logoifsc from './../assets/ifsclogo.png';
import logocdcc from './../assets/logocdcc.png';
import logocnpq from './../assets/logocnpg.png';
import logofapesp from './../assets/logofapesp.png';
import logocapes from './../assets/logocapes.png';



console.log(logo);


export default class Inicio extends React.Component {
    render() {
        return (
            <div className="dialogo col">
                <div className="row center containerdialogoFixo">
                    <div className='dialogoFixo bkColor3 '>
                        <a href="http://eic.ifsc.usp.br/" target="_blink">
                            <div className="logo border1">
                                <img src={logo} alt="Logo" href="http://eic.ifsc.usp.br/"/>
                            </div>
                        </a>
                    </div>
                </div>
                <div className='row center'>
                    <div className='dialogoContent bkColor2 Color2'>
                        
                        <div className="dialogoMain col center fullWidth center">
                            <div className="row center fullWidth">
                                <h1 className='Color3' >Caça Palavras</h1>
                            </div>
                            <div className="row center fullWidth">
                                <h2 className='Color1 margin-min'>Doenças Tropicais</h2><br/>
                            </div>
                            <div className="row center fullWidth">
                                <Link to="/instrucao1"><Button className='sizeButton borColor1 Color4 button1 buttonIncial'><h4>Iniciar</h4></Button></Link>
                            </div>
                        </div>
                            <div className="dialogoRodape row center fullWidth distributed3">
                                <Link to="/compartilhar"><Icon className='iconShare' icon='share-alt' size='lg'/></Link>
                                <Link to="/creditos"><Icon className='iconPg' icon='people-group' size='lg'/></Link>
                            </div>
                        
                    </div>
                    
                </div>
                <div  className='row distributed5 logoDivulgacao fullWidth'>
                    <a href="https://www2.ifsc.usp.br/portal-ifsc/" target="_blink">
                        <div className="logoPatrocinador">
                            <img src={logoifsc} alt="Logo"/>
                        </div>
                    </a>
                    <a href="https://cdcc.usp.br/" target="_blink">
                        <div className="logoPatrocinador" >
                            <img src={logocdcc} alt="Logo" style={{width: '55%'}} />
                        </div>
                    </a>
                    <a href="http://www.cnpq.br/" target="_blink">
                        <div className="logoPatrocinador">
                            <img src={logocnpq} alt="Logo"  />
                        </div>
                    </a>
                    <a href="http://www.fapesp.br/" target="_blink">
                        <div className="logoPatrocinador">
                            <img src={logofapesp} alt="Logo"  />
                        </div>
                    </a>
                    <a href="https://www.capes.gov.br/" target="_blink">
                        <div className="logoPatrocinador">
                            <img src={logocapes} alt="Logo" />
                        </div>
                    </a> 
                </div>
            </div>
        );
    }
}